import PropTypes from 'prop-types'
import React from 'react'
import Spinner from '@vtex/styleguide/lib/Spinner'
import { FormattedMessage } from 'react-intl'

function MessageLoader({ messageId }) {
  return (
    <div className="">
      <div
        id="messageLoaderContent"
        className="aspect-ratio--object z-999"
        data-testid="message-loader"
      >
        <div className={`aspect-ratio--object flex bg-white-90`} />
        <div className="aspect-ratio--object flex items-center tc f3-ns">
          <div className="flex-auto">
            <div className="f4-ns mv6 mv7-ns">
              <Spinner size={60} />
            </div>
            {messageId ? (
              <div className="message">
                <span>
                  <FormattedMessage id={messageId} />
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

MessageLoader.propTypes = {
  messageId: PropTypes.string,
}

export default MessageLoader
